import { render } from "./UiModalHeader.vue?vue&type=template&id=a2af67c2"
import script from "./UiModalHeader.vue?vue&type=script&lang=js"
export * from "./UiModalHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/actions-runner/_work/frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__